import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function PublicRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isAuthenticated) {
    // Honor the deep link the user originally opened (ProtectedRoute stashes
    // it in state.from). The moment login() flips isAuthenticated this
    // component re-renders and its Navigate RACES the Login page's own
    // navigate(redirectTo) — redirecting to "/" here used to win the race and
    // dump share-link recipients on the dashboard instead of the shared app.
    const from = location.state?.from;
    const to = from?.pathname ? `${from.pathname}${from.search || ''}` : '/';
    return <Navigate to={to} replace />;
  }

  return <Outlet />;
}
